module.exports = require('./helpers/bundle-url').getBundleURL('85k6C') + "logo.c51670a8.svg";